import AlertDialog from './alert-component';

export const alertService = AlertDialog.create();
